import { keepPreviousData, useQuery } from "@tanstack/react-query";
import {
  getUsersAwaitingVerification,
  VerificationFilterType,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { MS_TIME } from "Utils/TimeUtils";
import type { AwaitingVerificationParams } from "Api/Queries/User/awaitingVerificationTypes";

const USERS_NOT_VERIFIED_QUERY_KEY = "USERS_NOT_VERIFIED";

export const usersNotVerifiedKeys = {
  all: [USERS_NOT_VERIFIED_QUERY_KEY],
  byParams: (params: AwaitingVerificationParams) => [
    ...usersNotVerifiedKeys.all,
    params,
  ],
};

type QueryOptions = {
  enabled?: boolean;
  params?: AwaitingVerificationParams;
};

export const useUsersNotVerifiedQuery = ({
  enabled,
  params,
}: QueryOptions = {}) =>
  useQuery({
    queryKey: usersNotVerifiedKeys.byParams(params ?? {}),
    queryFn: processResponseWithApiProblemDetails(() =>
      getUsersAwaitingVerification(
        VerificationFilterType.UserVerification,
        params?.login,
        params?.firstName,
        params?.lastName,
        params?.companyName,
        params?.companyNumber,
        params?.roleCodes,
        params?.offset,
        params?.limit,
        params?.sortBy,
        params?.sortDirection,
      ),
    ),
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    staleTime: MS_TIME.minute,
    enabled,
  });
